import React from 'react';
import { Search, Download } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';

const LeadsToolbar = ({
  tab, setTab, tabCounts, search, setSearch,
  sourceFilter, setSourceFilter, sourceOptions, onExport,
}) => {
  const tabs = [
    { id: 'all', label: 'All Leads', count: tabCounts.all },
    { id: 'seller', label: 'Sellers', count: tabCounts.seller },
    { id: 'buyer', label: 'Buyers', count: tabCounts.buyer },
  ];

  return (
    <div className="p-5 border-b border-slate-200 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
      <div className="flex items-center gap-2">
        {tabs.map((t) => (
          <button
            key={t.id}
            data-testid={`tab-${t.id}`}
            onClick={() => setTab(t.id)}
            className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
              tab === t.id ? 'bg-emerald-600 text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
            }`}
          >
            {t.label} ({t.count})
          </button>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          <Input
            data-testid="admin-search"
            type="text"
            placeholder="Search name, email, city..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="pl-9 w-56 h-9 text-sm"
          />
        </div>
        <select
          data-testid="admin-source-filter"
          value={sourceFilter}
          onChange={(e) => setSourceFilter(e.target.value)}
          className="h-9 px-3 text-sm border border-slate-200 rounded-md bg-white"
        >
          {sourceOptions.map((s) => (
            <option key={s} value={s}>{s === 'all' ? 'All sources' : s}</option>
          ))}
        </select>
        <Button data-testid="admin-export-csv" size="sm" onClick={onExport} className="bg-emerald-600 hover:bg-emerald-700 text-white">
          <Download className="w-4 h-4 mr-1" /> CSV
        </Button>
      </div>
    </div>
  );
};

export default LeadsToolbar;
